<template>
  <div style="overflow-x: hidden;">
    <el-row :gutter="5" style="margin-left: 16px;margin-right: 16px;">
      <el-col :span="6" style="animation-duration: 500ms">
        <el-row :gutter="5">
          <el-col>
            <div class="overview_container" style="margin-bottom:5px;width: 100%;height: 230px;">
              <span class="title">总览信息</span>
              <el-row :gutter="5" style="margin-top: 30px;margin-left: 10px;margin-right: 10px;">
                <el-col :span="8">
                  <div class="overview_item_container"
                    style="margin-bottom:5px;width: 100%;height: 75px;text-align:center;">
                    <div class="esh1">{{ outlineData.orgData.orgDataUserValue }}</div>
                    <div class="esh2">接入工区</div>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="overview_item_container"
                    style="margin-bottom:5px;width: 100%;height: 75px;text-align:center;">
                    <div class="esh1">{{ outlineData.orgData.orgDataAssetValue }}</div>
                    <div class="esh2">接入车站</div>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="overview_item_container"
                    style="margin-bottom:5px;width: 100%;height: 75px;text-align:center;">
                    <div class="esh1">{{ outlineData.assetCount }}</div>
                    <div class="esh2">接入设备</div>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="5" style="margin-left: 10px;margin-right: 10px;">
                <el-col :span="8">
                  <div class="overview_item_container"
                    style="margin-bottom:5px;width: 100%;height: 75px;text-align:center;">
                    <div class="esh1">{{ outlineData.userCount }}</div>
                    <div class="esh2">接入人员</div>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="overview_item_container"
                    style="margin-bottom:5px;width: 100%;height: 75px;text-align:center;">
                    <div class="esh1">{{ outlineData.userCountScene }}</div>
                    <div class="esh2">现场人员</div>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div class="overview_item_container"
                    style="margin-bottom:5px;width: 100%;height: 75px;text-align:center;">
                    <div class="esh1">{{ outlineData.userCountDuty }}</div>
                    <div class="esh2">当值人员</div>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="5">
          <el-col>
            <div class="overview_container" style="margin-bottom:5px;width: 100%;height: 230px;">
              <span class="title">运维指标综合评定</span>
              <el-row :gutter="5">
                <el-col :span="6">
                  <el-row :gutter="5">
                    <div class="eshtarget" style="margin-left: 12px;">故障完成率</div>
                    <div class="eshtarget_item" style="background: #00d1c8;">
                    </div>
                  </el-row>
                  <el-row :gutter="5">
                    <div class="eshtarget" style="margin-left: 12px;">巡检完成率</div>
                    <div class="eshtarget_item" style="background: #00b7ff;">
                    </div>
                  </el-row>
                </el-col>
                <el-col :span="12">
                  <el-row :gutter="5">
                    <div id="divCircleChart" style="margin-top: 8px;height: 200px;width: 100%;"></div>
                  </el-row>
                </el-col>
                <el-col :span="6">
                  <el-row ::gutter="5">
                    <div>
                      <div class="eshtarget" style="margin-right: 12px;">任务完成率</div>
                      <div class="eshtarget_item" style="background: #f9da4f;">
                      </div>
                    </div>
                  </el-row>
                  <el-row ::gutter="5">
                    <div class="eshtarget" style="margin-right: 12px;">保养完成率</div>
                    <div class="eshtarget_item" style="background: #7d5afb;">
                    </div>

                  </el-row>
                </el-col>
              </el-row>

            </div>
          </el-col>
        </el-row>
        <el-row ::gutter="5">
          <el-col>
            <div class="rankback_container" style="margin-bottom:5px;width: 100%;height:calc(100vh - 575px)">
              <!-- height:calc(100vh - 350px) -->
              <span class="title">工区运维指标排行</span>
              <el-row ::gutter="5" style="margin-top: 20px;margin-left: 10px;margin-right: 10px;margin-bottom: 30px;">
                <el-col :span="8">
                  <div style="margin-bottom:5px;width: 100%;height: 65px;">
                    <el-tooltip placement="top">
                      <div slot="content" style="width: 220px;height: 230px; font-size: 16px;">
                        <div style="font-size: 17px;margin-top: 15px;margin-left: 20px;">{{ rankDataList != null &&
                          rankDataList[0] !=
                          null ?
                          rankDataList[0].name : '' }}</div>
                        <ul>
                          <li style="line-height: 40px;">
                            指标综合评定：{{ rankDataList != null && rankDataList[0] != null ? rankDataList[0].totalRate : 0 }}
                          </li>
                          <li style="line-height: 40px;">
                            故障完成率：{{ rankDataList != null && rankDataList[0] != null ? rankDataList[0].fauDoneRate : 0 }}
                          </li>
                          <li style="line-height: 40px;">
                            保养完成率：{{ rankDataList != null && rankDataList[0] != null ? rankDataList[0].maiDoneRate : 0 }}
                          </li>
                          <li style="line-height: 40px;">
                            巡检完成率：{{ rankDataList != null && rankDataList[0] != null ? rankDataList[0].insDoneRate : 0 }}
                          </li>
                          <li style="line-height: 40px;">
                            任务完成率：{{ rankDataList != null && rankDataList[0] != null ? rankDataList[0].taskDoneRate : 0 }}
                          </li>
                        </ul>
                      </div>
                      <div class="overview_first_container"
                        style="margin-top:16px; margin-left:calc((100% - 57px)/2);width: 57px;height: 65px;">
                      </div>
                    </el-tooltip>
                    <div style="width: 100%;height: 100%;text-align: center;">
                      <span class="titlerank">{{ rankDataList != null && rankDataList[0] != null ? rankDataList[0].name :
                        ''
                      }}</span>
                    </div>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div style="margin-bottom:5px;width: 100%;height: 65px;">
                    <el-tooltip placement="top">
                      <div slot="content" style="width: 220px;height: 230px; font-size: 16px;">
                        <div style="font-size: 17px;margin-top: 15px;margin-left: 20px;">{{ rankDataList != null &&
                          rankDataList[1] !=
                          null ?
                          rankDataList[1].name : '' }}</div>
                        <ul>
                          <li style="line-height: 40px;">
                            指标综合评定：{{ rankDataList != null && rankDataList[1] != null ? rankDataList[1].totalRate : 0 }}
                          </li>
                          <li style="line-height: 40px;">
                            故障完成率：{{ rankDataList != null && rankDataList[1] != null ? rankDataList[1].fauDoneRate : 0 }}
                          </li>
                          <li style="line-height: 40px;">
                            保养完成率：{{ rankDataList != null && rankDataList[1] != null ? rankDataList[1].maiDoneRate : 0 }}
                          </li>
                          <li style="line-height: 40px;">
                            巡检完成率：{{ rankDataList != null && rankDataList[1] != null ? rankDataList[1].insDoneRate : 0 }}
                          </li>
                          <li style="line-height: 40px;">
                            任务完成率：{{ rankDataList != null && rankDataList[1] != null ? rankDataList[1].taskDoneRate : 0 }}
                          </li>
                        </ul>
                      </div>
                      <div class="overview_second_container"
                        style="margin-top:16px; margin-left:calc((100% - 57px)/2);width: 57px;height: 65px;">
                      </div>
                    </el-tooltip>
                    <div style="width: 100%;height: 100%;text-align: center;">
                      <span class="titlerank">{{ rankDataList != null && rankDataList[1] != null ? rankDataList[1].name :
                        ''
                      }}</span>
                    </div>
                  </div>
                </el-col>
                <el-col :span="8">
                  <div style="margin-bottom:5px;width: 100%;height: 65px;">
                    <el-tooltip placement="top">
                      <div slot="content" style="width: 220px;height: 230px; font-size: 16px;">
                        <div style="font-size: 17px;margin-top: 15px;margin-left: 20px;">{{ rankDataList != null &&
                          rankDataList[2] !=
                          null ?
                          rankDataList[2].name : '' }}</div>
                        <ul>
                          <li style="line-height: 40px;">
                            指标综合评定：{{ rankDataList != null && rankDataList[2] != null ? rankDataList[2].totalRate : 0 }}
                          </li>
                          <li style="line-height: 40px;">
                            故障完成率：{{ rankDataList != null && rankDataList[2] != null ? rankDataList[2].fauDoneRate : 0 }}
                          </li>
                          <li style="line-height: 40px;">
                            保养完成率：{{ rankDataList != null && rankDataList[2] != null ? rankDataList[2].maiDoneRate : 0 }}
                          </li>
                          <li style="line-height: 40px;">
                            巡检完成率：{{ rankDataList != null && rankDataList[2] != null ? rankDataList[2].insDoneRate : 0 }}
                          </li>
                          <li style="line-height: 40px;">
                            任务完成率：{{ rankDataList != null && rankDataList[2] != null ? rankDataList[2].taskDoneRate : 0 }}
                          </li>
                        </ul>
                      </div>
                      <div class="overview_third_container"
                        style="margin-top:16px; margin-left:calc((100% - 57px)/2);width: 57px;height: 65px;">
                      </div>
                    </el-tooltip>
                    <div style="width: 100%;height: 100%;text-align: center;">
                      <span class="titlerank">{{ rankDataList != null && rankDataList[2] != null ? rankDataList[2].name :
                        ''
                      }}</span>
                    </div>
                  </div>
                </el-col>
              </el-row>
              <div
                style="margin-bottom:5px;width: 100%;height:calc(100vh - 750px);overflow-y: scroll;overflow-x: hidden;margin-top:50px;">
                <el-row ::gutter="5" class="rank" v-for="(item, index) in rankDataList" :key="index">
                  <el-col :span="2">
                    <div>
                      <span v-if="index == 0" style="color: #8b7113;font-size: 35px;">{{ index + 1 }}</span>
                      <span v-else-if="index == 2" style="color: #872116;font-size: 35px;">{{ index + 1 }}</span>
                      <span v-else style="color: #2b929d;font-size: 35px;">{{ index + 1 }}</span>
                    </div>
                  </el-col>
                  <el-col :span="22">
                    <el-tooltip placement="top">
                      <div slot="content" style="width: 220px;height: 230px; font-size: 16px;">
                        <div style="font-size: 17px;margin-top: 15px;margin-left: 20px;">{{ item.name }}</div>
                        <ul>
                          <li style="line-height: 40px;">
                            指标综合评定：{{ item.totalRate }}
                          </li>
                          <li style="line-height: 40px;">
                            故障完成率：{{ item.fauDoneRate }}
                          </li>
                          <li style="line-height: 40px;">
                            保养完成率：{{ item.maiDoneRate }}
                          </li>
                          <li style="line-height: 40px;">
                            巡检完成率：{{ item.insDoneRate }}
                          </li>
                          <li style="line-height: 40px;">
                            任务完成率：{{ item.taskDoneRate }}
                          </li>
                        </ul>
                      </div>
                      <div>
                        <div class="rank_item" style="background-color: #0b2535;">
                          <span style="font-size: 20px;color: #acafb0;">{{ item.name }}</span>
                        </div>
                        <div class="rank_itemdiv">
                          <div class="rank_context" :style="'width: ' + item.totalRate + '%;'"></div>
                        </div>
                      </div>
                    </el-tooltip>
                  </el-col>
                </el-row>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="12" style="animation-duration: 500ms">
        <el-row ::gutter="5">
          <el-col>
            <div style="width: 100%;height: 620px;">
              <div class="overview_map_container" style="margin-left:calc((100% - 945px)/2);width: 945px;height: 620px;">
                <template v-for="(item, index) in mapDataList">

                  <div class="overview_map_arma" v-if="item.direction == 1" :key="index"
                    :style="'height: 30px;width: 120px; top: ' + item.margintop + 'px;left: ' + item.marginleft + 'px;'">
                    <el-tooltip placement="top">
                      <div slot="content" style="width: 220px;height: 230px; font-size: 16px;">
                        <div style="font-size: 17px;margin-top: 15px;margin-left: 20px;">{{ item.name }}</div>
                        <ul>
                          <li style="line-height: 40px;">
                            指标综合评定：{{ item.totalRate }}
                          </li>
                          <li style="line-height: 40px;">
                            故障完成率：{{ item.fauDoneRate }}
                          </li>
                          <li style="line-height: 40px;">
                            保养完成率：{{ item.maiDoneRate }}
                          </li>
                          <li style="line-height: 40px;">
                            巡检完成率：{{ item.insDoneRate }} 
                          </li>
                          <li style="line-height: 40px;">
                            任务完成率：{{ item.taskDoneRate }}
                          </li>
                        </ul>
                      </div>
                      <em>{{ item.name }}</em>
                    </el-tooltip>
                  </div>
                  <div class="overview_map_arma" v-if="item.direction == 2" :key="index"
                    :style="'height: 120px;width: 30px; top: ' + item.margintop + 'px;left: ' + item.marginleft + 'px;writing-mode: tb-rl; '">
                    <el-tooltip placement="top">
                      <div slot="content" style="width: 220px;height: 230px; font-size: 16px;">
                        <div style="font-size: 17px;margin-top: 15px;margin-left: 20px;">{{ item.name }}</div>
                        <ul>
                          <li style="line-height: 40px;">
                            指标综合评定：{{ item.totalRate }}
                          </li>
                          <li style="line-height: 40px;">
                            故障完成率：{{ item.fauDoneRate }}
                          </li>
                          <li style="line-height: 40px;">
                            保养完成率：{{ item.maiDoneRate }}
                          </li>
                          <li style="line-height: 40px;">
                            巡检完成率：{{ item.insDoneRate }}
                          </li>
                          <li style="line-height: 40px;">
                            任务完成率：{{ item.taskDoneRate }}
                          </li>
                        </ul>
                      </div>
                      <em>{{ item.name }}</em>
                    </el-tooltip>
                  </div>
                </template>
              </div>
            </div>
          </el-col>
        </el-row>
        <el-row ::gutter="5">
          <el-col>
            <div class="overview_actual_container" style="margin-bottom: 16px;width: 100%;height: calc(100vh - 725px);">
              <div class="overview_actual1_container" style="width: 100%;height: 50px;">
                <span class="title" style="top: 10px;">实时故障信息</span>
              </div>
              <div style="height: calc(100vh - 775px);overflow-x: hidden;">
                <vue-seamless-scroll :data="nofinishFaults" :class-option="optionSingleHeight">
                  <div v-for="(item, index) in nofinishFaults" :key="index"
                    :class="index % 2 == 0 ? '' : 'overview_actual2_container'"
                    style="width: 100%;height: 75px;flex-direction: column;">
                    <el-row ::gutter="5" style="margin-left: 10px;margin-right: 10px;">
                      <el-col :span="16" style="color: #ffffff;font-size: 18px;padding-top: 10px;">
                        <span>
                          {{ item.org_name + '-' + item.area_name + '-' + item.equi_name }}
                        </span>
                        <span class="alarm_1" style="margin-left: 10px;">{{ item.level_name }}</span>
                      </el-col>
                      <el-col :span="8"
                        style="color: #ffffff;text-align: right;font-size: 18px;padding-top: 10px;">上报时间：{{
                          item.occu_time.replace('T', ' ').substring(0, 16) }}</el-col>
                    </el-row>
                    <el-row ::gutter="5" style="margin-left: 10px;margin-right: 10px;">
                      <el-col :span="12" style="color: #9fc9fc;font-size: 16.2px;padding-top: 10px;">{{ '【' + item.code +
                        '】' +
                        item.appe_name + (item.des == null ? '' : ('：' + item.des)) }}</el-col>
                      <el-col :span="12"
                        style="color: #9fc9fc;text-align: right;font-size: 16.2px;padding-top: 10px;">上报人：{{
                          item.reporte_name }}</el-col>
                    </el-row>
                  </div>
                </vue-seamless-scroll>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="6" style="animation-duration: 500ms">
        <el-row ::gutter="5">
          <el-col>
            <div class="totalldata_container" style="margin-bottom:5px;width: 100%;height: 230px;">
              <span class="title">总览数据</span>
              <el-row ::gutter="5">
                <el-col :span="8" style="margin-top: 30px;">
                  <div style="margin-bottom:5px;width: 100%;height: 60px;text-align:center;">
                    <el-col :span="22">
                      <div class="esh1">{{ outlineData.fautotal }}</div>
                      <div class="esh2">故障</div>
                    </el-col>
                    <el-col :span="2" style="width: 15px; height: 90%;margin-left: -10px;margin-top: 10px;">
                      <el-tooltip placement="left">
                        <div slot="content" style="width: 220px;height: 130px; font-size: 16px;">
                          <ul>
                            <li style="line-height: 40px;">
                              已发生故障数：{{ outlineData.fautotal }}
                            </li>
                            <li style="line-height: 40px;">
                              完成故障数：{{ outlineData.faufinishtotal }}
                            </li>
                            <li style="line-height: 40px;">
                              故障完成率：{{ outlineData.faufinishrate }}%
                            </li>
                          </ul>
                        </div>
                        <div class="totalldata-back_container" style="width: 100%;height: 100%;">
                          <div :style="'background-color: #1c8a91;height: ' + outlineData.faunotfinishrate + '%;'">
                          </div>
                        </div>
                      </el-tooltip>
                    </el-col>
                  </div>
                </el-col>
                <el-col :span="8" style="margin-top: 30px;">
                  <div style="margin-bottom:5px;width: 100%;height: 60px;text-align:center;">
                    <el-col :span="22">
                      <div class="esh1">{{ outlineData.tasktotal }}</div>
                      <div class="esh2">任务</div>
                    </el-col>
                    <el-col :span="2" style="width: 15px; height: 90%;margin-left: -15px;margin-top: 10px;">
                      <el-tooltip placement="left">
                        <div slot="content" style="width: 220px;height: 130px; font-size: 16px;">
                          <ul>
                            <li style="line-height: 40px;">
                              已发生任务数：{{ outlineData.tasktotal }}
                            </li>
                            <li style="line-height: 40px;">
                              完成任务数：{{ outlineData.taskfinishtotal }}
                            </li>
                            <li style="line-height: 40px;">
                              任务完成率：{{ outlineData.taskfinishrate }}%
                            </li>
                          </ul>
                        </div>
                        <div class="totalldata-back_container" style="width: 100%;height: 100%;">
                          <div :style="'background-color: #1c8a91;height: ' + outlineData.tasknotfinishrate + '%;'">

                          </div>
                        </div>
                      </el-tooltip>
                    </el-col>
                  </div>
                </el-col>
                <el-col :span="8" style="margin-top: 30px;">
                  <div style="margin-bottom:5px;width: 100%;height: 60px;text-align:center;">
                    <el-col :span="22">
                      <div class="esh1">{{ outlineData.repairtotal }}</div>
                      <div class="esh2">维修</div>
                    </el-col>
                    <el-col :span="2" style="width: 15px; height: 90%;margin-left: -18px;margin-top: 10px;">
                      <el-tooltip placement="left">
                        <div slot="content" style="width: 220px;height: 130px; font-size: 16px;">
                          <ul>
                            <li style="line-height: 40px;">
                              已发生维修数：{{ outlineData.repairtotal }}
                            </li>
                            <li style="line-height: 40px;">
                              完成维修数：{{ outlineData.repairfinishtotal }}
                            </li>
                            <li style="line-height: 40px;">
                              维修完成率：{{ outlineData.repairfinishrate }}%
                            </li>
                          </ul>
                        </div>
                        <div class="totalldata-back_container" style="width: 100%;height: 100%;">
                          <div :style="'background-color: #1c8a91;height: ' + outlineData.repairnotfinishrate + '%;'">

                          </div>
                        </div>
                      </el-tooltip>
                    </el-col>
                  </div>
                </el-col>
              </el-row>
              <el-row ::gutter="5">
                <el-col :span="12" style="margin-top: 5px;">
                  <div style="margin-bottom:5px;width: 100%;height: 60px;text-align:center;">
                    <el-col :span="22">
                      <div class="esh1">{{ outlineData.instotal }}</div>
                      <div class="esh2">巡检</div>
                    </el-col>
                    <el-col :span="2" style="width: 15px; height: 90%;margin-left: -18px;margin-top: 10px;">
                      <el-tooltip placement="left">
                        <div slot="content" style="width: 220px;height: 130px; font-size: 16px;">
                          <ul>
                            <li style="line-height: 40px;">
                              已发生巡检数：{{ outlineData.instotal }}
                            </li>
                            <li style="line-height: 40px;">
                              完成巡检数：{{ outlineData.insfinishtotal }}
                            </li>
                            <li style="line-height: 40px;">
                              巡检完成率：{{ outlineData.insfinishrate }}%
                            </li>
                          </ul>
                        </div>
                        <div class="totalldata-back_container" style="width: 100%;height: 100%;">
                          <div :style="'background-color: #1c8a91;height: ' + outlineData.insnotfinishrate + '%;'">

                          </div>
                        </div>
                      </el-tooltip>
                    </el-col>
                  </div>
                </el-col>
                <el-col :span="12" style="margin-top: 5px;">
                  <div style="margin-bottom:5px;width: 100%;height: 60px;text-align:center;">
                    <el-col :span="23">
                      <div class="esh1">{{ outlineData.maintaintotal }}</div>
                      <div class="esh2">保养</div>
                    </el-col>
                    <el-col :span="1" style="width: 15px;height: 90%;margin-left: -23px;margin-top: 10px;">
                      <el-tooltip placement="left">
                        <div slot="content" style="width: 220px;height: 130px; font-size: 16px;">
                          <ul>
                            <li style="line-height: 40px;">
                              已发生保养数：{{ outlineData.maintaintotal }}
                            </li>
                            <li style="line-height: 40px;">
                              完成保养数：{{ outlineData.maintainfinishtotal }}
                            </li>
                            <li style="line-height: 40px;">
                              保养完成率：{{ outlineData.maintainfinishrate }}%
                            </li>
                          </ul>
                        </div>
                        <div class="totalldata-back_container" style="width: 100%;height: 100%;">
                          <div :style="'background-color: #1c8a91;height: ' + outlineData.maintainnotfinishrate + '%;'">

                          </div>
                        </div>
                      </el-tooltip>
                    </el-col>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-col>
        </el-row>
        <el-row ::gutter="5">
          <el-col>
            <div class="overview_container" style="margin-bottom:5px;width: 100%;height:300px">
              <span class="title">实时数据</span>
              <el-row ::gutter="5" style="margin-left: 70px;margin-right: 70px;margin-top: 10px;">
                <el-col :span="12" style="text-align:center;">
                  <div class="today1">{{ outlineData.fautotalnow }}</div>
                  <div class="today2">故障</div>
                  <div class="today3 itmefau">
                    <div style="padding-top: 15px;">{{ outlineData.faufinishtotalnow }}%</div>
                  </div>
                </el-col>
                <el-col :span="12" style="text-align:center;">
                  <div class="today1">{{ outlineData.tasktotalnow }}</div>
                  <div class="today2">任务</div>
                  <div class="today3 itmetask">
                    <div style="padding-top: 15px;">{{ outlineData.taskfinishratenow }}%</div>
                  </div>
                </el-col>
              </el-row>
              <el-row ::gutter="5" style="margin-left: 20px;margin-right: 20px;margin-top: 10px;">
                <el-col :span="8" style="text-align:center;">
                  <div class="today1">{{ outlineData.instotalnow }}</div>
                  <div class="today2">巡检</div>
                  <div class="today3 itmeinl">
                    <div style="padding-top: 15px;">{{ outlineData.insfinishratenow }}%</div>
                  </div>
                </el-col>
                <el-col :span="8" style="text-align:center;">
                  <div class="today1">{{ outlineData.maintaintotalnow }}</div>
                  <div class="today2">保养</div>
                  <div class="today3 itmerost">
                    <div style="padding-top: 15px;">{{ outlineData.maintainfinishtotalnow }}%</div>
                  </div>
                </el-col>
                <el-col :span="8" style="text-align:center;">
                  <div class="today1">{{ outlineData.repairtotalnow }}</div>
                  <div class="today2">维修</div>
                  <div class="today3 itmerepair">
                    <div style="padding-top: 15px;">{{ outlineData.repairfinishratenow }}%</div>
                  </div>
                </el-col>
              </el-row>
            </div>
          </el-col>
        </el-row>
        <el-row ::gutter="5">
          <el-col>
            <div class="overview_container"
              style="margin-bottom:5px;width: 100%;height: calc(100vh - 645px);overflow-y: scroll;overflow-x: hidden;">
              <span class="title">综合数据分析</span>
              <div style="margin-left: 200px; top: 20px;right: 10px;">
                <el-date-picker v-model="dateTimeRadar" size="mini" type="daterange" style="width: 230px"
                  format="yyyy-MM-dd" value-format="yyyy-MM-dd" popper-class="pickerWrapZ1" range-separator="至"
                  start-placeholder="开始日期" end-placeholder="结束日期" @change="() => {

                    this.loadRadarChart()
                  }">
                </el-date-picker>
              </div>
              <div id="divRadarChart" style="top: 20px;right: 10px;height: 360px;width: 100%;">

              </div>

            </div>
          </el-col>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import cusradar from '../chart/cusradar.js'
import cuscircle from '../chart/cuscircle.js'
import dateutils from '../../utils/dateutils.js'

export default {
  name: 'dashboardoutline',
  props: {},
  data () {
    return {
      value1: [],
      nofinishFaults: [],
      rankDataList: [],
      mapDataList: [],
      outlineData: { orgData: {} },
      queryObjRadar: {},//查询条件，雷达图
      queryObjRank: {},
      dateTimeRadar: [],
      dateTimeRank: [],
    }
  },
  computed: {
    optionSingleHeight () {
      return {
                    limitMoveNum: 2, // 开始无缝滚动的数据量 this.dataList.length
                    singleHeight: 75, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
      }
    }
  },
  methods: {
    init () {
      let currTime = new Date()
      let beforeTime = new Date(currTime.getTime() - 1000 * 60 * 60 * 24 * 30)//当前时间前30天
      this.dateTimeRadar = [dateutils.dateFormat("YYYY-mm-dd 00:00:01", beforeTime), dateutils.dateFormat("YYYY-mm-dd 23:59:59", currTime)]

      this.dateTimeRank = [dateutils.dateFormat("YYYY-01-01 00:00:01", new Date()), dateutils.dateFormat("YYYY-mm-dd 23:59:59", new Date())]
      this.loadOutlineData()
      this.loadRankData()
      this.loadCircleChart()
      this.loadRadarChart()
      this.loadMapData()
    },
    loadMapData () {
      this.$ajax.get('/buss/dashboard/getDashbardMap').then((msg) => {
        msg.forEach((arr) => {
          arr.fauDoneRate = arr.fauAllNum == 0 ? 0 : Number(Number(arr.fauDoneNum * 100 / arr.fauAllNum).toFixed(0))
          arr.insDoneRate = arr.insAllNum == 0 ? 0 : Number(Number(arr.insDoneNum * 100 / arr.insAllNum).toFixed(0))
          arr.taskDoneRate = arr.taskAllNum == 0 ? 0 : Number(Number(arr.taskDoneNum * 100 / arr.taskAllNum).toFixed(0))
          arr.maiDoneRate = arr.maiAllNum == 0 ? 0 : Number(Number(arr.maiDoneNum * 100 / arr.maiAllNum).toFixed(0))
          arr.totalRate = Number(Number(arr.fauDoneRate * 0.4 + arr.insDoneRate * 0.2 + arr.taskDoneRate * 0.1 + arr.maiDoneRate * 0.3).toFixed(0))
        })
        let mapDataList = msg.sort((a, b) => { return b.name > a.name })
        this.mapDataList = mapDataList
        console.log("mapDataList", this.mapDataList)
      }).catch(err => {
        this.$message.error(err)
      })
    },
    loadRankData () {
      this.queryObjRank.starttime = this.dateTimeRank[0]
      this.queryObjRank.endtime = this.dateTimeRank[1]
      this.$ajax.get('/buss/dashboard/get_maintenance_indi', this.queryObjRank).then((msg) => {

        let msgFilter = msg.filter(ele => (!ele.name.includes('维修') && !ele.name.includes('消防')))
        msgFilter.forEach((arr) => {
          arr.fauDoneRate = arr.fauAllNum == 0 ? 0 : Number(Number(arr.fauDoneNum * 100 / arr.fauAllNum).toFixed(0))
          arr.insDoneRate = arr.insAllNum == 0 ? 0 : Number(Number(arr.insDoneNum * 100 / arr.insAllNum).toFixed(0))
          arr.taskDoneRate = arr.taskAllNum == 0 ? 0 : Number(Number(arr.taskDoneNum * 100 / arr.taskAllNum).toFixed(0))
          arr.maiDoneRate = arr.maiAllNum == 0 ? 0 : Number(Number(arr.maiDoneNum * 100 / arr.maiAllNum).toFixed(0))
          arr.totalRate = Number(Number(arr.fauDoneRate * 0.4 + arr.insDoneRate * 0.2 + arr.taskDoneRate * 0.1 + arr.maiDoneRate * 0.3).toFixed(0))
        })

        console.log("loadRankData", msgFilter)
        let rankDataList = msgFilter.sort((a, b) => { return b.totalRate - a.totalRate })
        this.rankDataList = rankDataList
      }).catch(err => {
        this.$message.error(err)
      })
    },

    //加载多层游泳圈图
    loadCircleChart () {

      this.$ajax.get('/buss/dashboard/get_maintenance_indi').then((msg) => {

        var fauDoneNum = 0
        var fauDisDoneNum = 0
        var fauAllNum = 0
        let insDoneNum = 0
        var insDisDoneNum = 0
        var insAllNum = 0
        var taskDoneNum = 0
        var taskDisDoneNum = 0
        var taskAllNum = 0
        var maiDoneNum = 0
        var maiDisDoneNum = 0
        var maiAllNum = 0

        for (var i = 0; i < msg.length; i++) {

          fauDoneNum += msg[i].fauDoneNum
          fauDisDoneNum += msg[i].fauDisDoneNum
          fauAllNum += msg[i].fauAllNum

          insDoneNum += msg[i].insDoneNum
          insDisDoneNum += msg[i].insDisDoneNum
          insAllNum += msg[i].insAllNum

          taskDoneNum += msg[i].taskDoneNum
          taskDisDoneNum += msg[i].taskDisDoneNum
          taskAllNum += msg[i].taskAllNum

          maiDoneNum += msg[i].maiDoneNum
          maiDisDoneNum += msg[i].maiDisDoneNum
          maiAllNum += msg[i].maiAllNum

        }

        var nameData = ['故障完成率', '巡检完成率', '任务完成率', '保养完成率']//分析项名称
        var areaData1 = [fauDoneNum, insDoneNum, taskDoneNum, maiDoneNum]//分析项第一指标值，完成数量
        var areaData2 = [fauDisDoneNum, insDisDoneNum, taskDisDoneNum, maiDisDoneNum]//分析项第二指标值，未完成数量
        var titleData = 85//图表中心值

        var fauDoneRate = 40
        var insDoneRate = 20
        var maiDoneRate = 30
        var taskDoneRate = 10
        if (fauAllNum != 0) {
          fauDoneRate = fauDoneNum * 40 / fauAllNum
        }
        if (insAllNum != 0) {
          insDoneRate = insDoneNum * 20 / insAllNum
        }
        if (taskAllNum != 0) {
          taskDoneRate = taskDoneNum * 10 / taskAllNum
        }
        if (maiAllNum != 0) {
          maiDoneRate = maiDoneNum * 30 / maiAllNum
        }

        titleData = Math.round(fauDoneRate + insDoneRate + maiDoneRate + taskDoneRate)

        /* 示例数据
              var nameData = ['故障完成率', '巡检完成率', '任务完成率', '保养完成率']//分析项名称
              var areaData1 = [54, 56, 100, 70]//分析项第一指标值，完成数量
              var areaData2 = [45, 43, 50, 30]//分析项第二指标值，未完成数量
              var titleData = 85//图表中心值
         */

        //绘制多层游泳圈图
        cuscircle.init('divCircleChart', nameData, areaData1, areaData2, titleData)

      }).catch(err => {
        this.$message.error(err)
      })


    },

    //加载雷达图
    loadRadarChart () {

      if (this.dateTimeRadar != null && this.dateTimeRadar.length == 2) {
        this.queryObjRadar.starttime = this.dateTimeRadar[0]
        this.queryObjRadar.endtime = this.dateTimeRadar[1]
      }
      else {
        this.queryObjRadar.starttime = null
        this.queryObjRadar.endtime = null
      }

      this.$ajax.get('/buss/dashboard/get_radar_data', this.queryObjRadar).then((msg) => {

        var insMaxData = Math.ceil(msg[0].insAllNum / 4) * 4 + 10 * 4//使刻度值都显示整数

        //获取雷达图相关数据
        let indicatorNameData = ["故障", "巡检", "保养", "任务", "维修"]//分析项名称
        let legendData = ["发布", "已完成"]//图例，分析指标
        let indicatorMaxData = [insMaxData, insMaxData, insMaxData, insMaxData, insMaxData]//分析项指标最大值
        let areaData1 = [msg[0].fauDoneNum, msg[0].insDoneNum, msg[0].maiDoneNum, msg[0].taskDoneNum, msg[0].repairDoneNum]//分析项第一指标值
        let areaData2 = [msg[0].fauAllNum, msg[0].insAllNum, msg[0].maiAllNum, msg[0].taskAllNum, msg[0].repairAllNum]//分析项第二指标值

        /* 示例数据
              //获取雷达图相关数据
              let indicatorNameData = ["故障", "巡检", "保养", "任务", "维修"]//分析项名称
              let legendData = ["发布", "已完成"]//图例，分析指标
              let indicatorMaxData = [88, 88, 88, 88, 88]//分析项指标最大值
              let areaData1 = [55, 85, 55, 85, 48]//分析项第一指标值
              let areaData2 = [65, 65, 75, 45, 85]//分析项第二指标值
         */
        //绘制雷达图
        cusradar.init('divRadarChart', indicatorNameData, legendData, indicatorMaxData, areaData1, areaData2)

      }).catch(err => {
        this.$message.error(err)
      })


    },

    loadOutlineData () {
      this.$ajax.get('/buss/dashboard/getOutLineDataNew').then((msg) => {
        this.outlineData = msg
        this.nofinishFaults = msg.nowfinishFaults
      }).catch(err => {
        this.$message.error(err)
      })
    },
  },
  mounted () {
    setTimeout(() => {
      this.init()
    }, 500)

    this.clearTimeSet = setInterval(() => {
      this.init()
    }, 30000)
  },
  beforeDestroy () {    //页面关闭时清除定时器  
    clearInterval(this.clearTimeSet);
  },

}
</script>

<style>
.card_container {
  color: #59f2ff;
  font-size: 14px;
  border: 1px solid #00aeff;
  border-radius: 5px;
  box-shadow: 0 0 15px #00aeff inset;
  background-color: transparent;
  width: 100%;
  height: 100px;
  margin-top: 8px;
}

.label {
  color: #dddddd;
  font-size: 16px;
  margin: 0px;
  margin-bottom: 8px;
}

.content {
  color: #59f2ff;
  font-size: 14px;
}

.esh1 {
  padding-top: 10px;
  color: #00fff4;
  font-size: 24px;
  /* font-weight: bold; */
}

.eshtarget {
  text-align: center;
  margin-top: 40px;
  color: #b3b3b3;
  font-size: 20px;
}

.eshtarget_item {
  width: 10px;
  height: 10px;
  -webkit-border-radius: 25px;
  -moz-border-radius: 25px;
  border-radius: 25px;
  margin-left: calc(100%/2);
  margin-top: 15px;
}

.esh2 {
  padding-bottom: 15px;
  color: #acafb0;
  font-size: 18px;
  /* font-weight: bold; */
}

tr {
  height: 30px;
}

.title {
  position: relative;
  color: #32c5ff;
  font-size: 20px;
  /* font-family: "黑体"; */
  font-weight: bold;
  top: 20px;
  left: 32px;
}

.titlerank {
  position: relative;
  color: #acafb0;
  font-size: 20px;
}

.rank {
  padding-top: 8px;
  padding-left: 20px;
}

.rank_item {
  width: 60%;
  height: 25px;
}

.rank_itemdiv {
  margin-top: 1px;
  width: 100%;
  height: 17px;
  background-color: #0c2738;
}

.rank_context {
  height: 17px;
  background-color: #10827e;
}

.c_alarm_panel {
  background-color: #003548;
  width: 100%;
  height: 70px;
  color: #59f2ff;
  text-align: center;
  font-size: 20px;
  margin-bottom: 12px;
  margin-left: 18px;
  width: calc(100% - 36px);
}

.alarm_1 {
  border: 2px solid #ffa500;
  font-weight: 700;
  padding: 4px 8px 4px 8px;
  color: #ffa500;
  font-size: 12px;
  transform: rotate(0deg);
  text-align: center;
  width: 60px;
}

.model-title {
  text-align: center;
  font-size: 18px;
  font-weight: bolder;
  position: relative;
  top: 10px;
  color: #ddd;
}

.model-content {
  color: #ddd;
  font-size: 14px;
  margin: 60px 80px 0px 80px;
  height: 520px;
}

.model_panel {
  position: absolute;
  z-index: 1001;
  left: 0;
  top: 0;
  width: 100%;
  height: 1080px;
  background: rgba(0, 0, 0, 0.2);
}

.model_large {
  width: 1200px;
  height: 658px;
  background: url(../../assets/imgs/dashboard/model1200x658.png) no-repeat;
  position: absolute;
  top: 200px;
  left: calc(50% - 600px);
}

.model_large .close {
  left: calc(50% + 600px);
  position: absolute;
  top: -20px;
}

.overview_container {
  background: url(../../assets/imgs/dashboard/newimgs/totallback.png) no-repeat;
  background-size: 100% 100%;
  margin-bottom: 5px;
}

.judgeback_container {
  background: url(../../assets/imgs/dashboard/newimgs/judgeback.png) no-repeat;
  background-size: 100% 100%;
  margin-bottom: 5px;
}

.totalldata_container {
  background: url(../../assets/imgs/dashboard/newimgs/totalldata.png) no-repeat;
  background-size: 100% 100%;
  margin-bottom: 5px;
}

.totalldata-back_container {
  background: url(../../assets/imgs/dashboard/newimgs/totalldataback1.png) no-repeat;
  background-size: 100% 100%;
}

.rankback_container {
  background: url(../../assets/imgs/dashboard/newimgs/rankback.png) no-repeat;
  background-size: 100% 100%;
  margin-bottom: 5px;
}

.overview_actual_container {
  background: url(../../assets/imgs/dashboard/newimgs/actualfau.png) no-repeat;
  background-size: 100% 100%;
  margin-bottom: 5px;
}

.overview_actual2_container {
  background: url(../../assets/imgs/dashboard/newimgs/actualfau2.png) no-repeat;
  background-size: 105% 100%;
}

.overview_actual1_container {
  background: url(../../assets/imgs/dashboard/newimgs/actualfau1.png) no-repeat;
  background-size: 105% 100%;
  margin-bottom: 5px;
}

.overview_todayrealtime_container {
  background: url(../../assets/imgs/dashboard/newimgs/todayrealtime.png) no-repeat;
  background-size: 100% 100%;
  margin-bottom: 5px;
}

.overview_map_container {
  background: url(../../assets/imgs/dashboard/newimgs/map.png) no-repeat;
  background-size: 100% 100%;
}

.overview_map_arma {
  position: relative;
  color: #dba82e;
  font-size: 20px;
  font-weight: bold;
  letter-spacing: 4px;

}

.overview_item_container {
  background: url(../../assets/imgs/dashboard/newimgs/total_item.png) no-repeat;
  background-size: 100% 100%;
  margin-bottom: 5px;
}

.overview_first_container {
  background: url(../../assets/imgs/dashboard/newimgs/first.png) no-repeat;
  background-size: 100% 100%;
  margin-bottom: 5px;
}

.overview_second_container {
  background: url(../../assets/imgs/dashboard/newimgs/second.png) no-repeat;
  background-size: 100% 100%;
  margin-bottom: 5px;
}

.overview_third_container {
  background: url(../../assets/imgs/dashboard/newimgs/third.png) no-repeat;
  background-size: 100% 100%;
  margin-bottom: 5px;
}

.noticeitem {
  padding-top: 5px;
  padding-left: 28px;
  color: #acafb0;
  font-size: 16px;
}

.today1 {
  color: #e9ecec;
  font-size: 24px;
}

.today2 {
  color: #e9ecec;
  font-size: 16px;
}

.today3 {
  width: 95px;
  height: 72px;
  text-align: center;
  margin-left: calc((100% - 95px)/2);
  font-size: 18px;
}

.itmefau {
  background: url(../../assets/imgs/dashboard/newimgs/fau\ \(2\).png) no-repeat;
  color: #09cfe9;
}

.itmerepair {
  background: url(../../assets/imgs/dashboard/newimgs/task.png) no-repeat;
  color: #0bd68c;
}

.itmeinl {
  background: url(../../assets/imgs/dashboard/newimgs/inl.png) no-repeat;
  color: #3177ff;
}

.itmetask {
  background: url(../../assets/imgs/dashboard/newimgs/task.png) no-repeat;
  color: #0bd68c;
}

.itmerost {
  background: url(../../assets/imgs/dashboard/newimgs/fau\ \(2\).png) no-repeat;
  color: #08def6;
}

.pickerWrapZ1 {
  background: #141418a9 !important;
  color: #ffffff;
  border: 1px solid #93bee7 !important;
  line-height: 20px;
}

.el-time-panel {
  background: #0e3646;
  border: 1px solid #16698d;
  color: #fff;
}

.el-time-spinner__item {
  color: #fff;
}

.el-time-spinner__item:hover:not(.disabled):not(.active) {
  color: #3bc9cbff;
  background: none;
}

.el-time-spinner__item.active:not(.disabled) {
  color: #3bc9cbff;
}

.el-time-panel__content::after,
.el-time-panel__content::before {
  border-top: 1px solid #16698d;
  border-bottom: 1px solid #16698d;
}

.el-time-panel__btn.confirm {
  color: #3bc9cbff;
}

.el-time-panel__btn {
  color: #ccc;
}

.el-time-panel__footer {
  border-top: 1px solid #16698d;
}

.popper__arrow::after {
  border-bottom-color: #0e3646 !important;
}

.popper__arrow {
  border-bottom-color: #16698d !important;
}

.el-picker-panel__footer {
  background: #0e3646;
}

.el-input__inner {
  color: #fff !important;
  background: #0e3646 !important;
  border: 1px solid #16698d !important;
}

.el-picker-panel__footer {
  border-top: 1px solid #16698d;
}

.el-date-table th {
  color: #fff;
  border-bottom: 1px solid #16698d;
}

.el-date-picker__header-label {
  color: #fff;
}

.el-date-picker__time-header {
  border-bottom: 1px solid #16698d;
}

.el-button.is-plain {
  background-color: #3bc9cbff;
  border: 1px solid #16698d;
  color: #fff;
}

.el-button.is-plain:focus,
.el-button.is-plain:hover {
  background-color: #3bc9cbff;
  border: 1px solid #16698d;
  color: #fff;
}

.el-date-table td.current:not(.disabled) span {
  background-color: #3bc9cbff;
  color: #fff;
}

.el-date-table td.today span {
  color: #3bc9cbff;
}

.el-button--text {
  color: #3bc9cbff;
}

.el-date-table td.available:hover {
  color: #3bc9cbff;
}

.el-date-picker__header--bordered {
  border-bottom: 1px solid #16698d;
}

.el-month-table td.current:not(.disabled) .cell,
.el-year-table td.current:not(.disabled) .cell {
  color: #fff;
  background-color: #3bc9cbff;
  border-radius: 5px;
}

.el-month-table td .cell:hover,
.el-year-table td .cell:hover {
  color: #3bc9cbff;
}

.el-month-table td .cell,
.el-year-table td .cell {
  color: #f5f5f5;
}

.el-month-table td.today .cell,
.el-year-table td.today .cell {
  color: #3bc9cbff;
}

.el-time-spinner__wrapper {
  width: 100% !important;
}

.el-scrollbar:nth-of-type(2) {
  display: none !important;
}

input.el-range-input {
  background-color: transparent;
}

.el-date-editor .el-range-separator {
  color: #C0C4CC;
}

.el-tooltip__popper {
  /* background: rgba(20, 20, 24, 0.5) !important; */
  background: rgba(5, 77, 99, 0.9) !important;
}

.el-tooltip__popper[x-placement^=top] .popper__arrow:after {
  border-top-color: #595959 !important;
}
</style>
